import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import PageHero from '../components/PageHero';
import Reveal, { RevealWords } from '../components/Reveal';
import SectionHeading from '../components/SectionHeading';
import Gallery from '../components/Gallery';
import Marquee from '../components/Marquee';
import Locations from '../components/Locations';
import { ArrowRight, Starburst } from '../components/Icons';
import { COPY, VALUES, SITE, MARQUEE } from '../data/site';
import { PHOTO } from '../data/media';
import './About.css';

// Mirrors the plates the old /about page showed, plus the bar.
const STORY_GALLERY = [
  { src: PHOTO.plate5, alt: 'A plate at The Local' },
  { src: PHOTO.plate9, alt: 'Served at the table' },
  { src: PHOTO.plate1, alt: 'From the kitchen' },
  { src: PHOTO.signatures, alt: 'Signature cocktails' },
  { src: PHOTO.lemonade, alt: 'Lavender lemonade at the bar' },
  { src: PHOTO.plate6, alt: 'On the pass' },
];

export default function About() {
  return (
    <>
      <Seo
        title="About"
        description="The Local was built on a simple idea — food tastes better when it belongs to the neighbourhood. Cafe, bar and restaurant in Bugolobi and Kyanja, Kampala."
        path="/about"
      />

      <PageHero
        eyebrow={`Est. ${SITE.established} · Kampala`}
        title={COPY.aboutHeading}
        lead={COPY.aboutOpener}
        image={PHOTO.plate5}
      />

      {/* Opening statement ------------------------------------------------ */}
      <section className="section about-open">
        <div className="page split split--wide-left">
          <div className="stack stack-md">
            <SectionHeading eyebrow="Why we opened" title="Not fancy belonging. Real belonging." />
            <Reveal as="p" className="body" delay={0.08}>
              {COPY.aboutMission}
            </Reveal>
            <Reveal as="p" className="body" delay={0.14}>
              {COPY.introBody}
            </Reveal>
            <Reveal as="p" className="body" delay={0.2}>
              {COPY.philosophyBody}
            </Reveal>
          </div>

          <Reveal className="about-open__media" variant="zoom">
            <div className="frame frame--3x4 frame--hover">
              <img src={PHOTO.plate9} alt="A dish plated at The Local" loading="lazy" />
            </div>
            <figcaption className="about-open__cap italic">{COPY.aboutMenuLine}</figcaption>
          </Reveal>
        </div>
      </section>

      <Marquee items={MARQUEE} />

      {/* Values ----------------------------------------------------------- */}
      <section className="section section--deep about-values">
        <div className="page stack stack-lg">
          <SectionHeading
            eyebrow="What we hold to"
            title="Three things we refuse to negotiate."
            align="center"
          />

          <ul className="about-values__grid">
            {VALUES.map((v, i) => (
              <Reveal as="li" className="valcard" key={v.n} delay={i * 0.1}>
                <span className="valcard__n tabular">{v.n}</span>
                <h3 className="display d4">{v.title}</h3>
                <p className="valcard__body">{v.body}</p>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>

      {/* Statement -------------------------------------------------------- */}
      <section className="section--dark grain about-statement">
        <div className="page on-dark about-statement__inner">
          <Reveal className="about-statement__mark">
            <Starburst size={52} />
          </Reveal>
          <p className="display brand d2 about-statement__quote">
            <RevealWords text="Food tastes better when it feels like it belongs to the neighbourhood." />
          </p>
          <Reveal delay={0.3}>
            <Link to="/menus" className="btn btn--gold">
              <span>See what we're cooking</span>
              <ArrowRight />
            </Link>
          </Reveal>
        </div>
      </section>

      {/* Gallery ---------------------------------------------------------- */}
      <section className="section">
        <div className="page stack stack-lg">
          <SectionHeading eyebrow="The room" title="Some evenings, in no order." />
          <Gallery items={STORY_GALLERY} variant="grid" />
        </div>
      </section>

      <Locations />
    </>
  );
}
